import React, { useState, useEffect } from 'react';
import Input from '../common/Input';
import { useFormik } from 'formik';
import AdminNavigation from './AdminNavigation';
import { getVendorAccountById, createVendorAccountRecharge, getVendorAccountRechargesById } from '../service/vendorService';
import SelectBox from '../common/SelectBox';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import DataTable from '../common/DataTable';

const VendorRecharge = (props) => {
   const { vendorAccountId } = props.match.params;
   const [accounts, setAccount] = useState([]);
   const [items, setItems] = useState([]);
   // const [recharges, setRecharges] = useState([]);
   const columns = [
      {
         columnCaption: 'Reference',
         columnKey: 'rechargeReference',
      },
      {
         columnCaption: 'Vendor Account',
         columnKey: 'vendorAccountId.vendorAccountName',
      },
      {
         columnCaption: 'Balance Before',
         columnKey: 'accountBalanceBefore',
      },
      {
         columnCaption: 'Recharged Amount',
         columnKey: 'rechargeAmount',
      },
      {
         columnCaption: 'Balance After',
         columnKey: 'accountBalanceAfter',
      },

      {
         columnCaption: 'Time',
         columnKey: 'rechargeDatetime',
      },
   ];
   const username = JSON.parse(localStorage.getItem('username'));
   const formik = useFormik({
      initialValues: { vendorAccount: {}, rechargeAmount: 0, rechargeReference: '' },
      validationSchema: validation,
      onSubmit: (values, setSubmitting) => {
         values.username = username;
         handleSaveRecharge(values);
         setSubmitting(false);
      },
   });

   const handleSaveRecharge = (requestData) => {
      createVendorAccountRecharge(requestData)
         .then((response) => {
            toast.info('Account recharge created successfully', { autoClose: 2000 });
            fetchVendorAccountRecharges();
         })
         .catch((error) => {
            console.dir(error);
         });
   };

   const fetchVendorAccountById = () => {
      getVendorAccountById(vendorAccountId)
         .then((response) => {
            const vendorAccount = response.data.data;
            setAccount((prevState) => {
               return [...prevState, vendorAccount];
            });
            formik.setFieldValue('vendorAccount', vendorAccount);
         })
         .catch((error) => {});
   };

   const fetchVendorAccountRecharges = () => {
      getVendorAccountRechargesById(vendorAccountId)
         .then((response) => {
            const accountRechages = response.data.data;
            setItems(accountRechages);
         })
         .catch((error) => {});
   };

   const handleCancel = () => {
      props.history.push('/VendorList');
   };

   useEffect(fetchVendorAccountById, []);
   useEffect(fetchVendorAccountRecharges, []);

   return (
      <div className='container'>
         <div className='row'>
            <div className='col-md-2'>
               <AdminNavigation />
            </div>
            <div className='col-md-10'>
               <form className='form' onSubmit={formik.handleSubmit}>
                  <div className='form-row'>
                     <div className='form-group col-md-8'>
                        <label>Vendor Account Id</label>
                        <SelectBox
                           name='vendorAccount'
                           id='vendorAccount'
                           label='Vendor Account'
                           getOptionLabel={({ vendorAccountName }) => vendorAccountName}
                           getOptionValue={(option) => option}
                           value={formik.values.vendorAccount}
                           options={accounts}
                           placeholder={'Account'}
                           onChange={(selected) => formik.setFieldValue('vendorAccount', selected)}
                           onBlur={(selected) => formik.setFieldTouched('vendorAccount', selected)}
                        />
                     </div>
                  </div>
                  <div className='form-row'>
                     <div className='form-group col-md-4'>
                        <label>Recharge Amount</label>
                        <Input
                           type='text'
                           className='form-control form-control-sm custom-input'
                           name='rechargeAmount'
                           id='rechargeAmount'
                           value={formik.values.rechargeAmount}
                           onChange={formik.handleChange}
                        />
                        {formik.errors.rechargeAmount && formik.touched.rechargeAmount && (
                           <div className='invalid-feedback'>{formik.errors.rechargeAmount}</div>
                        )}
                     </div>
                     <div className='form-group col-md-4'>
                        <label>Recharge Reference</label>
                        <Input
                           type='text'
                           className='form-control form-control-sm custom-input'
                           name='rechargeReference'
                           id='rechargeReference'
                           value={formik.values.rechargeReference}
                           onChange={formik.handleChange}
                        />
                        {formik.errors.rechargeReference && formik.touched.rechargeReference && (
                           <div className='invalid-feedback'>{formik.errors.rechargeReference}</div>
                        )}
                     </div>
                  </div>
                  <button type='submit' className='btn btn-primary btn-sm search-button mr-2'>
                     Recharge
                  </button>
                  <button type='button' className='btn btn-secondary btn-sm search-button' onClick={handleCancel}>
                     Cancel
                  </button>
               </form>
               <div className='mt-3 form'>
                  <DataTable items={items} pageSize={10} columns={columns}></DataTable>
               </div>
            </div>
         </div>
      </div>
   );
};

export default VendorRecharge;

const validation = Yup.object({
   rechargeAmount: Yup.number().min(100, 'Must be one hundred or more').required('Recharge amount is required'),
   rechargeReference: Yup.string().max(64, 'Must be 64 characters or less').required('Recharge reference required'),
   vendorAccount: Yup.object({
      vendorAccountId: Yup.number().required('Account Id is required'),
   }),
});
